import { render } from "./CreateEmployee.vue?vue&type=template&id=79d8d59b"
import script from "./CreateEmployee.vue?vue&type=script&lang=js"
export * from "./CreateEmployee.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__